import React from "react";
import { Link } from "react-router-dom";
import { FaCheck, FaShoppingCart } from "react-icons/fa";
import useMarketplaceAddToCart from "../../hooks/useMarketplaceAddToCart";

export default function MarketplaceAddToCartButton({
  item,
  className = "",
  iconOnly = false,
  onDark = false,
}) {
  const { addToCart, isAdding, isInCart } = useMarketplaceAddToCart();
  const productId = item?.id ?? item?.product_id;
  const inCart = isInCart(productId);
  const adding = isAdding(productId);

  if (iconOnly) {
    if (inCart) {
      return (
        <Link
          to="/my-cart"
          className={`${className} is-in-cart`}
          aria-label="View in cart"
          onClick={(e) => e.stopPropagation()}
        >
          <FaCheck aria-hidden />
        </Link>
      );
    }

    return (
      <button
        type="button"
        className={`${className}${adding ? " is-loading" : ""}`}
        aria-label="Add to cart"
        disabled={adding}
        onClick={(e) => void addToCart(item, e)}
      >
        <FaShoppingCart aria-hidden />
      </button>
    );
  }

  if (inCart) {
    return (
      <Link
        to="/my-cart"
        className={`${className} is-in-cart${onDark ? " is-in-cart--dark" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <FaCheck aria-hidden />
        Added to Cart
      </Link>
    );
  }

  return (
    <button
      type="button"
      className={className}
      disabled={adding}
      onClick={(e) => void addToCart(item, e)}
    >
      <FaShoppingCart aria-hidden />
      {adding ? "Adding…" : "Add to Cart"}
    </button>
  );
}
